class ResultsGridControl extends HTMLElement {

  constructor() {
    super();

    this.elements = {
      triggers: this.querySelectorAll('[data-results-grid-control-el="trigger"]'),
    }
  }

  connectedCallback() {
    this.attachEventListeners();
    this.stateRoot = window.theme.category ? window.theme.category.stateLayer : window.theme.searchResults.stateLayer
  }

  attachEventListeners() {
    this.elements.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleTriggerClick.bind(this, trigger))
    });
  }

  handleTriggerClick(trigger) {
    this.postCartAttribute(`_collection-view-${trigger.dataset.device}`, trigger.dataset.view)
    const device = trigger.dataset.device;
    const col = trigger.dataset.view;
    const grid = document.querySelector('.vbf-product-grid');
    const mql = window.matchMedia('(max-width: 750px)');

    if (mql.matches && device === 'mobile') {
      grid.setAttribute('data-mobile-grid-columns', col)
      grid.style.setProperty('--mobile-grid-columns', col)
    } else {
      grid.setAttribute('data-desktop-grid-columns', col)
      grid.style.setProperty('--desktop-grid-columns', col)
    }

    this.elements.triggers.forEach(el => {
      el.setAttribute('aria-pressed', 'false')

      if (el === trigger) {
        el.setAttribute('aria-pressed', 'true')
      }
    })
  }

  async postCartAttribute (key, value) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [key]: value,
          },
        }),
      })
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
    } catch (error) {
      console.error('Failed to update cart attribute:', error)
    }
  }
}

customElements.define('results-grid-control', ResultsGridControl);
